const components = {};
const files = import.meta.globEager("@/components/**/*.vue");
Object.entries(files).forEach(([path, definition]) => {
  const componentName = path.split("/").pop().split(".").shift();
  components[componentName] = definition.default;
});

export { components };
